import { useEffect, useRef } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import WhyUs from "@/components/landing/WhyUs";
import ChooseNeeds from "@/components/landing/ChooseNeeds";
import HowToOrder from "@/components/landing/HowToOrder";
import Gallery from "@/components/landing/Gallery";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";
import WhatsAppFab from "@/components/landing/WhatsAppFab";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 0.9, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: -64, duration: 1.4 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="App">
      <Navbar onNavigate={scrollTo} />
      <main>
        <Hero />
        <Marquee />
        <WhyUs />
        <ChooseNeeds />
        <HowToOrder />
        <Gallery />
        <Faq />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}

export default App;
